// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_modal__4mZpK {
  width: 42rem;
  max-width: 92vw; }

.styles_header__rrRH9 {
  padding: 1.15rem 1.4rem 0.85rem; }

.styles_headerWithTabs__YPMLM {
  border-bottom: 1px solid #8080802e;
  padding-bottom: 0.35rem; }

.styles_modalTitle__k3lIb {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  letter-spacing: 0.01em; }

.styles_contentContainer__G0Bw9 {
  height: 54vh;
  overflow-y: auto;
  padding: 0.75rem 1.15rem 1.15rem; }

.styles_selectableList__2viMe {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 0.25rem 0.15rem 0.5rem; }

.styles_selectableItem__ZG5p- {
  width: 100%;
  box-sizing: border-box;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #8080802e;
  border-radius: 0.9rem;
  background: #fff;
  cursor: pointer;
  transition: 0.2s border-color, 0.2s background-color, 0.2s box-shadow; }
  .styles_selectableItem__ZG5p-:hover {
    border-color: #72abab80;
    background: #73abab1a;
    box-shadow: 0 0.35rem 1.1rem #8080801a; }
    .styles_selectableItem__ZG5p-:hover .styles_selectButton__6QJMh {
      background: #fff;
      color: #72abab;
      border-color: #72abab; }

.styles_selectableCopy__AqEVH {
  min-width: 0;
  flex: 1 1; }

.styles_selectableName__J5Vwz {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3; }

.styles_selectableText__jqlWK {
  margin: 0.3rem 0 0;
  color: #808080b8;
  font-size: 0.86rem;
  line-height: 1.4;
  font-family: 'Raleway', 'Roboto', sans-serif;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; }

.styles_selectButton__6QJMh {
  flex-shrink: 0;
  min-width: unset !important;
  font-size: 0.82rem !important;
  font-weight: 600;
  line-height: 1;
  padding: 0.4rem 0.9rem !important;
  border-radius: 2rem;
  border: 1px solid #72abab80;
  background: #73abab1a;
  color: #72abab !important; }

.styles_emptyState__XozAG {
  height: 100%;
  min-height: 16rem;
  padding: 2rem 1.5rem;
  text-align: center; }

.styles_emptyTitle__GNnR4 {
  margin: 0;
  font-size: 1.05rem; }

.styles_emptyHint__qaRqq {
  max-width: 22rem;
  margin: 0.45rem 0 0;
  color: #808080b8;
  font-size: 0.9rem;
  line-height: 1.45;
  font-family: 'Raleway', 'Roboto', sans-serif; }
`, "",{"version":3,"sources":["webpack://./src/modules/cycles/components/ActivityForm/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,YAAY;EACZ,eAAe,EAAA;;AAGnB;EACI,+BAA+B,EAAA;;AAGnC;EACI,kCCCc;EDAd,uBAAuB,EAAA;;AAG3B;EACI,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB,EAAA;;AAG1B;EACI,YAAY;EACZ,gBAAgB;EAChB,gCAAgC,EAAA;;AAGpC;EACI,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,+BAA+B,EAAA;;AAGnC;EACI,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,2BC3Bc;ED4Bd,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,qEAAqE,EAAA;EATzE;IAYQ,uBCLgB;IDMhB,qBCJgB;IDKhB,sCCrCU,EAAA;IDuBlB;MAiBY,gBAAgB;MAChB,cCdQ;MDeR,qBCfQ,EAAA;;ADoBpB;EACI,YAAY;EACZ,SAAO,EAAA;;AAGX;EACI,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAA;;AAGpB;EACI,kBAAkB;EAClB,gBCxDc;EDyDd,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGpB;EACI,cAAc;EACd,2BAA2B;EAC3B,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,2BClDoB;EDmDpB,qBCjDoB;EDkDpB,yBAA6B,EAAA;;AAGjC;EACI,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB,EAAA;;AAGtB;EACI,SAAS;EACT,kBAAkB,EAAA;;AAGtB;EACI,gBAAgB;EAChB,mBAAmB;EACnB,gBC/Fc;EDgGd,iBAAiB;EACjB,iBAAiB;EACjB,4CAA4C,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.modal {\n    width: 42rem;\n    max-width: 92vw;\n}\n\n.header {\n    padding: 1.15rem 1.4rem 0.85rem;\n}\n\n.headerWithTabs {\n    border-bottom: 1px solid $grey18;\n    padding-bottom: 0.35rem;\n}\n\n.modalTitle {\n    margin: 0 0 0.35rem;\n    font-size: 1.35rem;\n    letter-spacing: 0.01em;\n}\n\n.contentContainer {\n    height: 54vh;\n    overflow-y: auto;\n    padding: 0.75rem 1.15rem 1.15rem;\n}\n\n.selectableList {\n    display: flex;\n    flex-direction: column;\n    gap: 0.65rem;\n    padding: 0.25rem 0.15rem 0.5rem;\n}\n\n.selectableItem {\n    width: 100%;\n    box-sizing: border-box;\n    gap: 1rem;\n    padding: 0.85rem 1rem;\n    border: 1px solid $grey18;\n    border-radius: 0.9rem;\n    background: #fff;\n    cursor: pointer;\n    transition: 0.2s border-color, 0.2s background-color, 0.2s box-shadow;\n\n    &:hover {\n        border-color: $ocean_blue50;\n        background: $ocean_blue10;\n        box-shadow: 0 0.35rem 1.1rem $grey10;\n\n        .selectButton {\n            background: #fff;\n            color: $ocean_blue;\n            border-color: $ocean_blue;\n        }\n    }\n}\n\n.selectableCopy {\n    min-width: 0;\n    flex: 1;\n}\n\n.selectableName {\n    margin: 0;\n    font-size: 1.05rem;\n    font-weight: 600;\n    line-height: 1.3;\n}\n\n.selectableText {\n    margin: 0.3rem 0 0;\n    color: $grey72;\n    font-size: 0.86rem;\n    line-height: 1.4;\n    font-family: 'Raleway', 'Roboto', sans-serif;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n.selectButton {\n    flex-shrink: 0;\n    min-width: unset !important;\n    font-size: 0.82rem !important;\n    font-weight: 600;\n    line-height: 1;\n    padding: 0.4rem 0.9rem !important;\n    border-radius: 2rem;\n    border: 1px solid $ocean_blue50;\n    background: $ocean_blue10;\n    color: $ocean_blue !important;\n}\n\n.emptyState {\n    height: 100%;\n    min-height: 16rem;\n    padding: 2rem 1.5rem;\n    text-align: center;\n}\n\n.emptyTitle {\n    margin: 0;\n    font-size: 1.05rem;\n}\n\n.emptyHint {\n    max-width: 22rem;\n    margin: 0.45rem 0 0;\n    color: $grey72;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    font-family: 'Raleway', 'Roboto', sans-serif;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `styles_modal__4mZpK`,
	"header": `styles_header__rrRH9`,
	"headerWithTabs": `styles_headerWithTabs__YPMLM`,
	"modalTitle": `styles_modalTitle__k3lIb`,
	"contentContainer": `styles_contentContainer__G0Bw9`,
	"selectableList": `styles_selectableList__2viMe`,
	"selectableItem": `styles_selectableItem__ZG5p-`,
	"selectButton": `styles_selectButton__6QJMh`,
	"selectableCopy": `styles_selectableCopy__AqEVH`,
	"selectableName": `styles_selectableName__J5Vwz`,
	"selectableText": `styles_selectableText__jqlWK`,
	"emptyState": `styles_emptyState__XozAG`,
	"emptyTitle": `styles_emptyTitle__GNnR4`,
	"emptyHint": `styles_emptyHint__qaRqq`
};
export default ___CSS_LOADER_EXPORT___;
